import "@fontsource/pt-serif"
import './src/styles/global.css';
import * as React from 'react';
import Layout from '@/components/layout';

export const wrapPageElement = ({ element, props }) => {
    // props provide access to location, pageContext, etc.
    return <Layout {...props}>{element}</Layout>;
};
